<template>
  <ul class="business-menu fl">
    <li v-for="(item,index) in businessMenu" :key="index">
      <router-link tag="div" :to="{path:item.url}" class="menu-tit active">
        <span :class="'icon-business-menu icon-'+item.icon"></span>
        <span>{{item.name}}</span>
        <i class="el-icon-arrow-right"></i>
      </router-link>
      <ul class="sub-menu" v-for="(subItem,subIndex) in item.subMenu" :key="subIndex">
        <router-link class="active" :to="{path:subItem.url}" tag="li">{{subItem.name}}</router-link>
      </ul>
    </li>
    <li v-if="$store.getters.user.shopId" class="menu-tit active" @click="checkCelebrityStatus()">
      <span class="icon-business-menu"></span>
      <span>名人申请</span>
      <i class="el-icon-arrow-right"></i>
    </li>
  </ul>
</template>
<script>
    import {getCelebrityExamineInfo} from '../../api/shop'
  export default {
      data(){
          return {
              status:0,
              businessMenu:[
                  {
                      id:0,
                      icon:'profit',
                      name:'店铺营收',
                      url:'/business'
                  },
                  {
                      id:1,
                      icon:'chart',
                      name:'订单数据',
                      url:'/business/order'
                  },
                  {
                      id:2,
                      icon:'goods',
                      name:'商品管理',
                      url:'/business/goodsManage'
                  },
                  {
                      id:3,
                      icon:'edit',
                      name:'发布商品',
                      url:'/business/releaseGoods',
                      subMenu:[
                          {
                              id:30,
                              name:'竞拍商品',
                              url:'/business/releaseGoods'
                          },
                          {
                              id:30,
                              name:'视频商品',
                              url:'/business/releaseVideoGoods'
                          },
                          {
                              id:31,
                              name:'普通商品',
                              url:'/business/releaseGeneralGoods'
                          }
                      ]
                  },
                  {
                      id:4,
                      icon:'shop',
                      name:'店铺管理',
                      url:'/business/edit'

                  }
              ]
          }
      },
      components:{
      },
      created () {
      },
      mounted(){
          getCelebrityExamineInfo().then(res=>{
              this.status=res.data;
          }).catch(()=>{})
      },
      methods:{
          checkCelebrityStatus(){
              if(!this.status){
                  this.$router.push({
                      path:'/business/celebrityApply'
                  });
                  return;
              }
              switch (this.status.status){
                  case 0:
                      this.$message({
                          message:'名人申请审核中...',
                          type:'warning'
                      });
                      break;
                  case 1:
                      break;
                  case 2:
                      this.$message({
                          message:'名人申请已经审核成功，无需再提交',
                          type:'warning'
                      });
                      break;
                  default:
                      this.$router.push({
                          path:'/business/celebrityApply'
                      })
                      break;
              }

          },
          handleOpen(key, keyPath) {
              console.log(key, keyPath);
          },
          handleClose(key, keyPath) {
              console.log(key, keyPath);
          }
      }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/common";
.business-menu{
  background-color:#fff;
  /*width:140px;*/
  padding:0px 20px;
  font-size:20px;
  color:#333;
  font-weight: 500;
  line-height:70px;
  .menu-tit{
    @include hover-color;
    position: relative;
    .icon-business-menu{
      display: inline-block;
      width:25px;
      height:25px;
      margin-right:10px;
      vertical-align: middle;
    }
    .icon-profit{background: url('../../assets/images/icons/icon-profit.png')no-repeat center;}
    .icon-chart{background: url('../../assets/images/icons/icon-chart.png')no-repeat center;}
    .icon-edit{background: url('../../assets/images/icons/icon-edit.png')no-repeat center;}
    .icon-goods{background: url('../../assets/images/icons/icon-goods.png')no-repeat center;}
    .icon-shop{background: url('../../assets/images/icons/icon-shop.png')no-repeat center;}
  }
  .sub-menu{
    font-size:16px;padding-left:35px;
    li{line-height:50px;@include hover-color;}
  }
  .active.router-link-active{color:$main-color;}
}
</style>
